import React, { useState, useEffect } from 'react';
import PuenteApi from '../../../../../pageauth/PuenteApi';
import Cargando from '../../../../../Cargando';
import Swal from 'sweetalert2';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { FaPencilAlt, FaTrash, FaSearch, FaHistory } from 'react-icons/fa';
import CryptoJS from 'crypto-js';
import AuthUser from '../../../../../pageauth/AuthUser';

export const RW_TiradasAlBuzon = ({ tipoModulo }) => {
    const { ObtenerEstaciones, ObtenerModulos, ObtenerTiradasAlBuzon, ActualizarTiradaAlBuzon, EliminarTiradaAlBuzon } = PuenteApi();
    const { StartCargando, StopCargando } = Cargando();
    const { getUser } = AuthUser();

    const [estaciones, setEstaciones] = useState([]);
    const [modulos, setModulos] = useState([]);
    const [tiradas, setTiradas] = useState([]);
    const [filtros, setFiltros] = useState({
        estacionId: "",
        moduloId: "",
        fechaInicio: "",
        fechaFin: ""
    });

    const [showModalEditar, setShowModalEditar] = useState(false);
    const [tiradaEditar, setTiradaEditar] = useState(null);
    const [formDataEditar, setFormDataEditar] = useState({
        monto: "",
        numtirada: "",
        motivo: ""
    });

    const [showModalHistorial, setShowModalHistorial] = useState(false);
    const [historial, setHistorial] = useState([]);

    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

    useEffect(() => {
        const estacionesGuardadas = localStorage.getItem("estaciones");
        if (estacionesGuardadas) {
            const bytes = CryptoJS.AES.decrypt(estacionesGuardadas, SECRET_KEY);
            const parsed = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            setEstaciones(parsed);
            obtenerTiradas(parsed);
        } else {
            obtenerEstaciones();
        }
    }, []);

    useEffect(() => {
        if (filtros.estacionId) {
            obtenerModulosDeEstacion(filtros.estacionId);
        } else {
            setModulos([]);
            setFiltros(prev => ({ ...prev, moduloId: "" }));
        }
    }, [filtros.estacionId]);

    const obtenerEstaciones = async () => {
        StartCargando("Cargando estaciones...");
        const response = await ObtenerEstaciones();
        if (response) {
            setEstaciones(response);
            localStorage.setItem("estaciones", CryptoJS.AES.encrypt(JSON.stringify(response), SECRET_KEY).toString());
            await obtenerTiradas(response);
        }
        StopCargando();
    };

    const obtenerModulosDeEstacion = async (estacionId) => {
        const estacion = estaciones.find(e => e.id == estacionId);
        if (estacion) {
            StartCargando("Cargando módulos...");
            const response = await ObtenerModulos(estacion.endpoint);
            let modulosObtenidos = response || [];
            if (tipoModulo) {
                modulosObtenidos = modulosObtenidos.filter(m => m.nombre === tipoModulo);
            }
            setModulos(modulosObtenidos);
            StopCargando();
        }
    };

    const obtenerTiradas = async (listaEstaciones, filtrosAplicados = filtros) => {
        StartCargando("Cargando tiradas...");
        let todasLasTiradas = [];

        const fetchFromEstacion = async (estacion) => {
            const params = {
                fecha_inicio: filtrosAplicados.fechaInicio,
                fecha_fin: filtrosAplicados.fechaFin,
                limit: 20
            };

            if (filtrosAplicados.moduloId) {
                const [modulo, sector] = filtrosAplicados.moduloId.split('|');
                params.modulo = modulo;
                params.sector = sector;
            } else if (tipoModulo) {
                params.modulo = tipoModulo;
            }

            const res = await ObtenerTiradasAlBuzon(estacion.endpoint, params);
            if (res) {
                return res.map(t => ({ ...t, nombreEstacion: estacion.nombre, endpoint: estacion.endpoint }));
            }
            return [];
        };

        if (filtrosAplicados.estacionId) {
            const estacion = listaEstaciones.find(e => e.id == filtrosAplicados.estacionId);
            if (estacion) {
                todasLasTiradas = await fetchFromEstacion(estacion);
            }
        } else {
            for (const estacion of listaEstaciones) {
                const res = await fetchFromEstacion(estacion);
                todasLasTiradas = [...todasLasTiradas, ...res];
            }
        }

        todasLasTiradas.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setTiradas(todasLasTiradas);
        StopCargando();
    };

    const handleFiltroChange = (e) => {
        const { name, value } = e.target;
        setFiltros(prev => ({ ...prev, [name]: value }));
    };

    const handleBuscar = () => {
        obtenerTiradas(estaciones, filtros);
    };

    const handleEditar = (tirada) => {
        setTiradaEditar(tirada);
        setFormDataEditar({
            monto: tirada.monto,
            numtirada: tirada.numtirada,
            motivo: ""
        });
        setShowModalEditar(true);
    };

    const handleGuardarEdicion = async () => {
        if (!formDataEditar.motivo) {
            Swal.fire('Error', 'Debe ingresar un motivo para la modificación', 'error');
            return;
        }

        StartCargando("Guardando cambios...");
        const data = {
            id: tiradaEditar.id,
            monto: formDataEditar.monto,
            numtirada: formDataEditar.numtirada,
            motivo: formDataEditar.motivo,
            usuario: getUser()
        };

        const res = await ActualizarTiradaAlBuzon(tiradaEditar.endpoint, data);
        StopCargando();

        if (res && res.success) {
            Swal.fire('Éxito', 'Tirada actualizada correctamente', 'success');
            setShowModalEditar(false);
            obtenerTiradas(estaciones, filtros);
        } else {
            Swal.fire('Error', res?.error || 'No se pudo actualizar la tirada', 'error');
        }
    };

    const handleEliminar = (tirada) => {
        Swal.fire({
            title: '¿Está seguro?',
            text: `Se eliminará la tirada N° ${tirada.numtirada}. Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                StartCargando("Eliminando...");
                const res = await EliminarTiradaAlBuzon(tirada.endpoint, tirada.id);
                StopCargando();
                if (res && res.success) {
                    Swal.fire('Eliminado', 'La tirada ha sido eliminada.', 'success');
                    obtenerTiradas(estaciones, filtros);
                } else {
                    Swal.fire('Error', res?.error || 'No se pudo eliminar la tirada', 'error');
                }
            }
        });
    };

    const handleVerHistorial = (tirada) => {
        try {
            const mods = typeof tirada.modificaciones === 'string' ? JSON.parse(tirada.modificaciones) : (tirada.modificaciones || []);
            setHistorial(mods);
            setShowModalHistorial(true);
        } catch (e) {
            console.error("Error parsing historial", e);
            setHistorial([]);
            setShowModalHistorial(true);
        }
    };

    return (
        <div className="card shadow-sm p-3">
            <h4 className="text-primary mb-4">Gestión de Tiradas al Buzón</h4>

            <div className="row mb-3">
                <div className="col-md-3">
                    <Form.Group>
                        <Form.Label>Estación</Form.Label>
                        <Form.Select name="estacionId" value={filtros.estacionId} onChange={handleFiltroChange}>
                            <option value="">Todas las estaciones</option>
                            {estaciones.map(e => <option key={e.id} value={e.id}>{e.nombre}</option>)}
                        </Form.Select>
                    </Form.Group>
                </div>
                <div className="col-md-3">
                    <Form.Group>
                        <Form.Label>Módulo/Sector</Form.Label>
                        <Form.Select name="moduloId" value={filtros.moduloId} onChange={handleFiltroChange} disabled={!filtros.estacionId}>
                            <option value="">Todos los módulos</option>
                            {modulos.map(m => (
                                <option key={`${m.nombre}|${m.sector}`} value={`${m.nombre}|${m.sector}`}>
                                    {m.nombre} - Sector {m.sector}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </div>
                <div className="col-md-2">
                    <Form.Group>
                        <Form.Label>Desde</Form.Label>
                        <Form.Control type="date" name="fechaInicio" value={filtros.fechaInicio} onChange={handleFiltroChange} />
                    </Form.Group>
                </div>
                <div className="col-md-2">
                    <Form.Group>
                        <Form.Label>Hasta</Form.Label>
                        <Form.Control type="date" name="fechaFin" value={filtros.fechaFin} onChange={handleFiltroChange} />
                    </Form.Group>
                </div>
                <div className="col-md-2 d-flex align-items-end">
                    <Button variant="primary" className="w-100" onClick={handleBuscar}>
                        <FaSearch /> Buscar
                    </Button>
                </div>
            </div>

            <div className="table-responsive">
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr className="bg-light">
                            <th>Estación</th>
                            <th>N° Tirada</th>
                            <th>Módulo</th>
                            <th>Sector</th>
                            <th>Empleado</th>
                            <th>Monto</th>
                            <th>Fecha</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tiradas.length > 0 ? (
                            tiradas.map(t => (
                                <tr key={`${t.endpoint}-${t.id}`}>
                                    <td>{t.nombreEstacion}</td>
                                    <td>{t.numtirada}</td>
                                    <td>{t.modulo}</td>
                                    <td>{t.sector}</td>
                                    <td>{t.empleado}</td>
                                    <td className="text-end font-weight-bold">${parseFloat(t.monto).toLocaleString('es-AR', { minimumFractionDigits: 2 })}</td>
                                    <td>{new Date(t.created_at).toLocaleString()}</td>
                                    <td>
                                        <Button variant="outline-primary" size="sm" className="me-1" title="Editar" onClick={() => handleEditar(t)}>
                                            <FaPencilAlt />
                                        </Button>
                                        <Button variant="outline-danger" size="sm" className="me-1" title="Eliminar" onClick={() => handleEliminar(t)}>
                                            <FaTrash />
                                        </Button>
                                        {t.modificaciones && (
                                            <Button variant="outline-info" size="sm" title="Ver Historial" onClick={() => handleVerHistorial(t)}>
                                                <FaHistory />
                                            </Button>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" className="text-center">No se encontraron tiradas</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            {/* Modal Editar */}
            <Modal show={showModalEditar} onHide={() => setShowModalEditar(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Editar Tirada al Buzón</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Número de Tirada</Form.Label>
                            <Form.Control
                                type="number"
                                value={formDataEditar.numtirada}
                                onChange={(e) => setFormDataEditar({ ...formDataEditar, numtirada: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Monto</Form.Label>
                            <Form.Control
                                type="number"
                                step="0.01"
                                value={formDataEditar.monto}
                                onChange={(e) => setFormDataEditar({ ...formDataEditar, monto: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Motivo de la modificación</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Explique por qué se realiza el cambio..."
                                value={formDataEditar.motivo}
                                onChange={(e) => setFormDataEditar({ ...formDataEditar, motivo: e.target.value })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalEditar(false)}>Cancelar</Button>
                    <Button variant="primary" onClick={handleGuardarEdicion}>Guardar Cambios</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal Historial */}
            <Modal show={showModalHistorial} onHide={() => setShowModalHistorial(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Historial de Modificaciones</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {historial.length > 0 ? (
                        <div className="timeline-container">
                            {historial.map((mod, idx) => (
                                <div key={idx} className="mb-4 p-3 border rounded bg-light">
                                    <div className="d-flex justify-content-between mb-2">
                                        <strong>{mod.usuario_nombre}</strong>
                                        <span className="text-muted small">{new Date(mod.fecha).toLocaleString()}</span>
                                    </div>
                                    <p className="mb-2"><strong>Motivo:</strong> {mod.motivo}</p>
                                    <div className="small">
                                        <strong>Cambios:</strong>
                                        <ul className="mb-0">
                                            {Object.keys(mod.cambios).map(key => (
                                                <li key={key}>
                                                    {key === 'monto' ? 'Monto' : 'N° Tirada'}: {mod.cambios[key].anterior} {'->'} {mod.cambios[key].nuevo}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="text-center">No hay historial disponible</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalHistorial(false)}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
